import { render, staticRenderFns } from "./PlanningTableSkeletonMobile.vue?vue&type=template&id=60a027dd&lang=pug&functional=true&"
import script from "./PlanningTableSkeletonMobile.vue?vue&type=script&lang=js&"
export * from "./PlanningTableSkeletonMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports